import HttpReference from '../../platform/HttpReference';
import Customer from './Customer';
import Stripe from './Stripe';

export default class Customers extends HttpReference<void, Customer, Stripe> {
  get childReferenceType() {
    return Customer;
  }
}
